import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Algo deu errado. Tente de novo.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.termos) return `${d.mensagem}: ${d.termos.map((t) => `"${t.termo}" (sugestão: ${t.sugestao})`).join(", ")}`;
  if (d.erros) return d.erros.join(" • ");
  if (d.campos) return Object.values(d.campos).join(" • ");
  return d.mensagem || JSON.stringify(d);
}

export const fieldErrors = (e) => e?.response?.data?.detail?.campos || {};
export const fileUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND}${u}` : u);
